<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn pull-right" @click="addCentralStreet(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Номи</th>
                      <th>Коди</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-for="result in results.data" :key="result.id">
                  <tr>
                      <td>{{result.id}}</td>
                      <td>{{result.name}}</td>
                      <td>{{result.code}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="edit(result)">
                              <i class="fa fa-edit"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                                  @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CentralStreetEditModal />
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import CentralStreetEditModal from './CentralStreetEditModal'
    export default {
        components: {
            'b-pagination': bPagination,
            CentralStreetEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: {}
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('central-street/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            addCentralStreet(data) {
                this.$eventBus.$emit('showCentralStreetAdd',data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            edit(data) {
                this.$eventBus.$emit("showCentralStreetAdd",data)
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('showCentralStreetChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>